import Resource from './Resource'

class EducationLevel extends Resource {
  static urlRoot() {
    return '/contracts/spain/education_levels'
  }
}

export default EducationLevel
